export default {
  data: {
    flights: '',
    style: null
  },
  loading: false,
  initialData: null,
  injectedEnv: null,
  defaultEnv: 'prod',
  token: null,
  currencyFormatter: null,
  isVisible: false,
  flightId: null,
  passengerId: null,
  isModalVisible: false,
  modalText: '',
  modalType: 'warning',
  autoChangeFlight: true,
  mobileLegendOnTop: false,
  confirming: false
}



// WEBPACK FOOTER //
// ./src/data/state.js